//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moduleName from '~/static/moduleName.json';
import roomId from '~/static/roomId.json';
// import languages from '~/static/languages.json'

export default {
  name: "SearchModuleSessionOfDay",
  data: function data() {
    return {
      searchKey: {
        moduleName: null,
        currentDateRaw: null
        // language:null,
      },
      roomId: roomId,
      moduleName: moduleName
      // language:languages
    };
  },
  updated: function updated() {
    console.log('cal updated', this.searchKey);
  },

  methods: {
    searchModuleSessionOfDay: function searchModuleSessionOfDay() {
      console.log('\n\n ====== Search Key Listening from Search Of Day ======\n', this.searchKey, '\n======================================');

      this.$emit('searchModuleSessionOfDay', this.searchKey);
    },
    resetAll: function resetAll() {
      this.searchKey = {
        moduleName: null,
        currentDateRaw: null
      };
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/dashboard/SearchModuleSessionOfDay.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/dashboard/SearchModuleSessionOfDay.vue
// module chunks = 1 2 3 4 10